
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { User, LogOut, Bot, Home } from 'lucide-react';

interface DashboardHeaderProps {
  firstName: string;
  onSignOut: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ firstName, onSignOut }) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0EA5E9]">Dashboard</h1>
        <p className="text-gray-600">Welcome, {firstName || 'User'}</p>
      </div>
      <div className="flex flex-row gap-2 w-full sm:w-auto">
        <Link to="/job-seeker-dashboard" className="w-auto">
          <Button 
            variant="outline" 
            className="flex gap-2 items-center border-[#0EA5E9] text-[#0EA5E9] hover:bg-[#0EA5E9]/10 w-auto"
          >
            <Home className="h-4 w-4" />
            <span>Dashboard</span>
          </Button>
        </Link>
        <Link to="/agent-builder" className="w-auto">
          <Button 
            variant="outline" 
            className="flex gap-2 items-center border-[#0EA5E9] text-[#0EA5E9] hover:bg-[#0EA5E9]/10 w-auto"
          >
            <Bot className="h-4 w-4" />
            <span>Agent Builder</span>
          </Button>
        </Link>
        <Link to="/job-seeker-profile" className="w-auto">
          <Button 
            variant="outline" 
            className="flex gap-2 items-center border-[#0EA5E9] text-[#0EA5E9] hover:bg-[#0EA5E9]/10 w-auto"
          >
            <User className="h-4 w-4" />
            <span>Profile</span>
          </Button>
        </Link>
        <Button 
          variant="outline" 
          className="flex gap-2 items-center border-[#0EA5E9] text-[#0EA5E9] hover:bg-[#0EA5E9]/10 w-auto"
          onClick={onSignOut}
        >
          <LogOut className="h-4 w-4" />
          <span>Sign Out</span>
        </Button>
      </div>
    </div>
  );
};

export default DashboardHeader;
